import Swiper from 'swiper';
import { Navigation, Mousewheel, Keyboard, Autoplay, EffectFade } from 'swiper/modules';
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';

gsap.registerPlugin(ScrollToPlugin);

let instances = []; // para destrucción al salir de móvil
let heroSwiperInstance = null;

const MOBILE_QUERY = '(max-width: 768px)';

const makeCounterUpdater = (swiper, el) => () => {
   if (!el || !swiper) return;
   const current = (swiper.realIndex ?? swiper.activeIndex) + 1;
   const total = swiper.slides?.length ?? 1;
   el.textContent = `${current}/${total}`;
};

const initOne = (root) => {
   const container = root.querySelector('.js-swiper--project');
   const prevEl = root.querySelector('.js-swiper-prev');
   const nextEl = root.querySelector('.js-swiper-next');
   const counterEl = root.querySelector('.js-swiper-counter');

   if (!container) return null;

   const swiper = new Swiper(container, {
      modules: [Navigation],
      slidesPerView: 1,       // 1 item por vista
      spaceBetween: 0,
      centeredSlides: false,
      loop: false,
      allowTouchMove: true,   // swipe táctil
      resistanceRatio: 0.85,
      navigation: {
         prevEl,
         nextEl
      }
   });

   // Actualizar contador al init y al cambiar
   const update = makeCounterUpdater(swiper, counterEl);
   swiper.on('init', update);
   swiper.on('slideChange', update);
   // Swiper >=8 dispara init internamente, pero forzamos el primer update
   update();

   return swiper;
};

const destroyAll = () => {
   instances.forEach((s) => {
      try { s?.destroy(true, true); } catch (e) { }
   });
   instances = [];
};

const ensureForViewport = (matches) => {
   if (matches) {
      // móvil -> init si no está
      if (!instances.length) {
         document.querySelectorAll('.s-project-swiper[data-swiper]').forEach((root) => {
            const sw = initOne(root);
            if (sw) instances.push(sw);
         });
      }
   } else {
      // desktop -> destroy
      destroyAll();
   }
};

export const initPressScrollSnap = () => {
   // Native CSS scroll-snap-type handles 100% of snapping cleanly
};

export const initSwiperProject = () => {
   const mql = window.matchMedia(MOBILE_QUERY);
   ensureForViewport(mql.matches);
   // escuchar cambios de viewport
   mql.addEventListener('change', (e) => ensureForViewport(e.matches));
};

export const initHomeHeroSwiper = () => {
   const container = document.querySelector('.js-hero-swiper');
   if (!container) return null;
   if (heroSwiperInstance) return heroSwiperInstance;

   // Check number of slides
   const slides = container.querySelectorAll('.swiper-slide');
   if (slides.length <= 1) return null;

   heroSwiperInstance = new Swiper(container, {
      modules: [Autoplay, EffectFade],
      effect: 'fade',
      fadeEffect: {
         crossFade: true
      },
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      speed: 1200,
      autoplay: {
         delay: 4500,
         disableOnInteraction: false
      },
      allowTouchMove: true,
      on: {
         slideChangeTransitionStart: function() {
            const activeSlide = this.slides[this.activeIndex];
            if (activeSlide) {
               const vid = activeSlide.querySelector('video');
               if (vid) {
                  vid.play().catch(() => {});
               }
            }
         }
      }
   });

   // Play first active slide video
   const firstVid = container.querySelector('.swiper-slide-active video, .swiper-slide:first-child video');
   if (firstVid) {
      firstVid.play().catch(() => {});
   }

   return heroSwiperInstance;
};

// Also expose globally so gsap timeline can trigger it cleanly
if (typeof window !== 'undefined') {
   window.initHomeHeroSwiper = initHomeHeroSwiper;
}